import { post } from "../../utils/Backend";
import { useLongfansMock } from "../../global/GlobalMock";
import {
  mockGetLatestViewpoints,
  mockGetOldViewpoints,
  mockGetPinnedViewpoints,
  mockListViewpointCategories,
  mockToggleViewpointCollect,
  mockToggleViewpointLike,
} from "./ViewpointFeedMock";
import type {
  ViewpointFeedCategoryListResult,
  ViewpointFeedEngagementParam,
  ViewpointFeedEngagementState,
  ViewpointFeedListKind,
  ViewpointFeedSliceQuery,
  ViewpointFeedSliceResult,
  ViewpointPinnedListQuery,
  ViewpointPinnedListResult,
} from "./ViewpointFeedTypes";

/** 本地调试 Mock 时改为 useLongfansMock；关闭 Mock 时 `&& false` */
const mockViewpointFeed = useLongfansMock && false;

const oldUrls: Record<ViewpointFeedListKind, string> = {
  all:
    process.env.REACT_APP_VIEWPOINT_FEED_OLD_URL?.trim() ||
    "/lark/app/viewpointFeed/getOldViewpoints",
  liked:
    process.env.REACT_APP_VIEWPOINT_FEED_OLD_LIKED_URL?.trim() ||
    "/lark/app/viewpointFeed/getOldLikedViewpoints",
  collected:
    process.env.REACT_APP_VIEWPOINT_FEED_OLD_COLLECTED_URL?.trim() ||
    "/lark/app/viewpointFeed/getOldCollectedViewpoints",
};

const latestUrls: Record<ViewpointFeedListKind, string> = {
  all:
    process.env.REACT_APP_VIEWPOINT_FEED_LATEST_URL?.trim() ||
    "/lark/app/viewpointFeed/getLatestViewpoints",
  liked:
    process.env.REACT_APP_VIEWPOINT_FEED_LATEST_LIKED_URL?.trim() ||
    "/lark/app/viewpointFeed/getLatestLikedViewpoints",
  collected:
    process.env.REACT_APP_VIEWPOINT_FEED_LATEST_COLLECTED_URL?.trim() ||
    "/lark/app/viewpointFeed/getLatestCollectedViewpoints",
};

const URL_PINNED =
  process.env.REACT_APP_VIEWPOINT_FEED_PINNED_URL?.trim() ||
  "/lark/app/viewpointFeed/getPinnedViewpoints";
const URL_TOGGLE_LIKE =
  process.env.REACT_APP_VIEWPOINT_FEED_TOGGLE_LIKE_URL?.trim() ||
  "/lark/app/viewpointFeed/toggleViewpointLike";
const URL_TOGGLE_COLLECT =
  process.env.REACT_APP_VIEWPOINT_FEED_TOGGLE_COLLECT_URL?.trim() ||
  "/lark/app/viewpointFeed/toggleViewpointCollect";
const URL_LIST_CATEGORIES =
  process.env.REACT_APP_VIEWPOINT_FEED_LIST_CATEGORIES_URL?.trim() ||
  "/lark/app/viewpointFeed/listViewpointCategories";

export const ViewpointFeedApi = {
  async getOldViewpoints(
    query: ViewpointFeedSliceQuery,
    kind: ViewpointFeedListKind = "all"
  ): Promise<ViewpointFeedSliceResult | string> {
    if (mockViewpointFeed) {
      return mockGetOldViewpoints(query, kind);
    }
    return post<ViewpointFeedSliceQuery, ViewpointFeedSliceResult>(oldUrls[kind], query, {
      silent: true,
    });
  },

  async getLatestViewpoints(
    query: ViewpointFeedSliceQuery,
    kind: ViewpointFeedListKind = "all"
  ): Promise<ViewpointFeedSliceResult | string> {
    if (mockViewpointFeed) {
      return mockGetLatestViewpoints(query, kind);
    }
    return post<ViewpointFeedSliceQuery, ViewpointFeedSliceResult>(latestUrls[kind], query, {
      silent: true,
    });
  },

  async getPinnedViewpoints(
    query: ViewpointPinnedListQuery
  ): Promise<ViewpointPinnedListResult | string> {
    if (mockViewpointFeed) {
      return mockGetPinnedViewpoints(query);
    }
    return post<ViewpointPinnedListQuery, ViewpointPinnedListResult>(URL_PINNED, query, {
      silent: true,
    });
  },

  async toggleLike(
    param: ViewpointFeedEngagementParam
  ): Promise<ViewpointFeedEngagementState | string> {
    if (mockViewpointFeed) {
      return mockToggleViewpointLike(param);
    }
    return post<ViewpointFeedEngagementParam, ViewpointFeedEngagementState>(
      URL_TOGGLE_LIKE,
      param,
      { silent: true }
    );
  },

  async toggleCollect(
    param: ViewpointFeedEngagementParam
  ): Promise<ViewpointFeedEngagementState | string> {
    if (mockViewpointFeed) {
      return mockToggleViewpointCollect(param);
    }
    return post<ViewpointFeedEngagementParam, ViewpointFeedEngagementState>(
      URL_TOGGLE_COLLECT,
      param,
      { silent: true }
    );
  },

  async listViewpointCategories(query: {
    spaceId: string;
    spaceProductId: string;
  }): Promise<ViewpointFeedCategoryListResult | string> {
    if (mockViewpointFeed) {
      return mockListViewpointCategories(query);
    }
    return post<
      { spaceId: string; spaceProductId: string },
      ViewpointFeedCategoryListResult
    >(URL_LIST_CATEGORIES, query, {
      silent: true,
    });
  },
};
